import React from 'react';
import { useEffect } from 'react'
import { Outlet, Navigate } from 'react-router-dom';
import { useGlobalContext } from '../../context';


const UserRoutes = () => {

    const{ fetchUserData} = useGlobalContext();

    const role = window.sessionStorage.getItem('role');

    useEffect(()=>{
        fetchUserData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //clear session storage timeout
    useEffect(() => {
        const timeout = setTimeout(() => {
            window.sessionStorage.clear();
        }, 1800000);

        return () => clearTimeout(timeout);
    }, []);

    return role === 'user' ? <Outlet /> : <Navigate to = '/Signin' />
};

export default UserRoutes;
